module.exports = __webpack_public_path__ + "img/welcome-1.ed430adf.png";